<save-page pageTitle="SMARTs"
           newButtonLabel="NEW SMART"
           [tabSetConfig]="tabSetConfig"
           (newButtonClicked)="newSmart()">
</save-page>
